import { render, staticRenderFns } from "./AssemblyManagementCreate.vue?vue&type=template&id=309f95f2"
import script from "./AssemblyManagementCreate.vue?vue&type=script&lang=js"
export * from "./AssemblyManagementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports